import { createSelector } from 'reselect';
import { getValue, hasContentValue, parentPath } from '@truqc/content-path';
import { convertToAbsolutePath } from '../utils';
import { getContent } from './simpleSelectors';
import newPathSelector from './newPathSelector';
const getOnNullDependentPaths = (state, props) => {
  const {
    format = {}
  } = props;
  const {
    onNull = {}
  } = format;
  const {
    dependentContentPaths = []
  } = onNull;
  return dependentContentPaths;
};
export default createSelector([getContent, getOnNullDependentPaths, newPathSelector], (content, contentPaths, currentPath) => contentPaths.some(path => {
  const absolutePath = convertToAbsolutePath(path, parentPath(currentPath));
  return hasContentValue(getValue(absolutePath, content));
}));